import React from 'react';

function InspectionNotSelected({ message }) {
  return (
    <div className="h-100 d-flex justify-content-center align-items-center bg-white">
      {message || '検品する受注を左の受注一覧から選んでください'}
    </div>
  );
}

export default InspectionNotSelected;